import { Box, Flex, Select, Text } from '@chakra-ui/react';
import { collection, getDocs } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import firebaseFirestore from '~/config/firebase/firestore';
import PanelActividad from '~/pages/private/activity/PanelActividad';

type Negocio = { id: string; name: string };

/**
 * La misma actividad que ve cada cliente, pero pudiendo elegir el negocio.
 *
 * Convive con la pantalla de registros que ya existía: aquella sigue siendo el
 * detalle técnico de todo lo que ocurre, y esta responde de un vistazo quién
 * tocó qué reserva.
 */
const ActividadSuperadmin = () => {
  const [negocios, setNegocios] = useState<Negocio[]>([]);
  const [companyId, setCompanyId] = useState('');

  useEffect(() => {
    const cargar = async () => {
      const snap = await getDocs(collection(firebaseFirestore, 'companies'));
      const lista = snap.docs
        .map((d) => ({ id: d.id, name: (d.data().name as string) ?? d.id }))
        .sort((a, b) => a.name.localeCompare(b.name));
      setNegocios(lista);
      // Se preselecciona el primero para no mostrar una pantalla vacía.
      if (lista.length > 0) setCompanyId((actual) => actual || lista[0].id);
    };
    cargar();
  }, []);

  return (
    <Box>
      <Flex align='center' gap={3} mb={2} px={{ base: 3, md: 6 }} pt={2}>
        <Text fontSize='sm' color='gray.600'>
          Negocio
        </Text>
        <Select
          size='sm'
          maxW='260px'
          borderRadius='md'
          value={companyId}
          onChange={(e) => setCompanyId(e.target.value)}
        >
          {negocios.map((n) => (
            <option key={n.id} value={n.id}>
              {n.name}
            </option>
          ))}
        </Select>
      </Flex>
      <PanelActividad companyId={companyId} sinTitulo />
    </Box>
  );
};

export default ActividadSuperadmin;
